
const QuotePage = () => {
  return (
    <div className='flex flex-col min-h-screen'>
      <div className='flex-grow'>
        <div className='container mx-auto px-4 py-8'>
          {/* Main content area */}
          <div className='bg-white rounded-lg shadow p-6'>
            <h1 className='text-2xl font-bold mb-4'>Quote Generation</h1>
            <p className='text-gray-600'>
              The development goes here. This page will be used to generate
              quotes based on the selected application and its details.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotePage;
